/*!

 =========================================================
 * Ouvidoria 
 =========================================================
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// router setup
import routes from './routes/routes'

import './registerServiceWorker'

import axios from 'axios'
import VueAxios from 'vue-axios'

// URL padrao
//Servidor em Produção
axios.defaults.baseURL = 'https://api-ouv.saojosedeuba.rj.gov.br/api/';
//Servidor de Desenvolvimento
//axios.defaults.baseURL = 'http://127.0.0.1:8000/api/';

// token padrao
axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem("token");

import VModal from 'vue-js-modal'
Vue.use(VModal)

Vue.use(VueAxios, axios)

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(VuejQueryMask)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VueSimpleAlert from "vue-simple-alert"
Vue.use(VueSimpleAlert)

import VueMeta from 'vue-meta';

Vue.use(VueMeta);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  //mode: 'history'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
